export class GlobalConstants {
  public static latitude = '23.8859';
  public static longitude = '45.0792';
}
